import React from 'react';
import { aplanarCategorias } from '../../utils/categoriasArbol';

// Espacios no separables ( ): los espacios normales se colapsan dentro de <option>
const SANGRIA = '\u00A0\u00A0\u00A0';

/**
 * Select de categorías que muestra la jerarquía con sangría por nivel.
 * Recibe la lista plana del API admin (con `padreId`); el resto de props
 * (value, onChange, className, style, name, required...) pasan al <select>.
 * `idsDeshabilitados` (Set) deja esas opciones visibles pero no seleccionables,
 * para conservar el contexto jerárquico.
 */
const CategoriaSelect = ({ categorias, placeholder, idsDeshabilitados, ...selectProps }) => (
  <select {...selectProps}>
    <option value="">{placeholder}</option>
    {aplanarCategorias(categorias).map((c) => (
      <option key={c.id} value={c.id} disabled={idsDeshabilitados?.has(c.id) || undefined}>
        {SANGRIA.repeat(c.nivel)}
        {c.nombre}
      </option>
    ))}
  </select>
);

export default CategoriaSelect;
